<template>
  <div class="prompt-item"> 
    <img 
      :src="props.prompt.image_url"  
      @click="handleClick" 
      alt="prompt image" 
      class="prompt-image"
    />
    <p class="prompt-description">{{ props.prompt.prompt }}</p>
    <!-- <button @click="goToColoring(props.prompt)" class="color-btn">🎨</button> -->
  </div>
</template>

<script setup lang="ts">
import Prompt from '@/types/Prompt'

const props = defineProps<{ prompt: Prompt }>()
const emit = defineEmits<{ (e: 'select', prompt: Prompt): void }>()

function handleClick() {
  emit('select', props.prompt)
}
</script>


<style scoped>

.prompt {
  display: flex;
  flex: 1;
  min-width: 300px;
}

.prompt-item {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  box-sizing: border-box; 
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.prompt-item:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-color: #157e15; */
}

.prompt-description {
  margin-bottom: 8px;
  text-align: left;
}

.prompt-image {
  flex-grow: 1; 
  object-fit: contain;
  max-height: 100%;
  width: 100%;
  border-radius: 4px;
  transition: transform 0.3s ease;
  cursor: pointer;
}


.prompt-image:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-color: #157e15;
}

</style>